<template>
  <div class="container">
    <div @click="CloseDrawer" size="medium" v-if="drawer && CourseworkForm.subject_code == 1" style="
                                                                                    position: fixed;
                                                                                    z-index: 10000;
                                                                                    float: left;
                                                                                    bottom: 0px;
                                                                                    right: 0px;
                                                                                    color: white;
                                                                                    border: 0px;
                                                                                  ">
      <el-image style="width: 45px; height: 45px" src="https://wugecdn.steam.fun/resources/jrcode/back3.png" fit="fit"></el-image>
    </div>

    <el-button @click="CloseDrawer" size="medium" v-if="drawer && CourseworkForm.subject_code == 2" style="
                                                                                    position: fixed;
                                                                                    z-index: 10000;
                                                                                    float: right;
                                                                                    top: 8px;
                                                                                    right: 10px;
                                                                                    background: #66b1ff7d;
                                                                                    color: white;
                                                                                    border: 0px;
                                                                                  ">
      <svg t="1665542150306" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="2543" width="15" height="15">
        <path d="M1024 505.679012c0-10.835979-4.815991-21.069959-12.039976-27.691946l-403.941211-361.199295c-6.621987-5.417989-14.447972-9.029982-23.477954-9.029982-20.46796 0-36.721928 16.855967-36.721928 37.925926l0 159.529688C238.993533 356.985303 21.069959 591.764844 0 893.366255c1.203998 12.641975 11.437978 22.875955 23.477954 22.875955 4.815991 0 9.631981-1.805996 13.243974-4.213992 0 0 0 0 0 0 53.577895-39.129924 99.329806-68.627866 135.449735-87.891828 87.28983-49.965902 222.739565-89.697825 375.045267-105.951793l0 148.091711c0 21.069959 16.253968 37.925926 36.721928 37.925926 8.427984 0 16.253968-3.611993 22.875955-8.427984l403.941211-361.199295c0 0 0 0 0 0C1019.184009 527.35097 1024 517.11699 1024 505.679012z" p-id="2544" fill="#ffffff"></path>
        <path d="M467.151088 380.463257c-33.711934 6.019988-96.921811 24.681952-139.061728 80.667842-7.223986 9.029982-5.417989 22.875955 3.611993 30.099941 0 0 0 0 0.601999 0 9.029982 7.223986 21.671958 5.417989 28.895944-3.009994 23.477954-28.895944 51.771899-57.189888 111.971781-65.015873 9.631981-1.203998 17.457966-9.631981 17.457966-19.865961l0-3.009994C490.027043 387.687243 478.589065 378.65726 467.151088 380.463257z" p-id="2545" fill="#ffffff"></path>
        <path d="M323.273369 518.320988C322.67137 518.320988 322.67137 518.320988 323.273369 518.320988c-12.039976-6.019988-25.885949 0.601999-28.895944 12.641975-2.407995 9.631981-4.815991 19.865961-6.019988 30.70194-1.805996 12.039976 7.223986 22.875955 19.263962 22.875955l3.611993 0c10.23398 0 18.661964-7.825985 19.263962-17.457966 0.601999-7.825985 1.805996-13.243974 4.213992-24.681952C337.119342 532.768959 331.701352 522.534979 323.273369 518.320988z" p-id="2546" fill="#ffffff"></path>
      </svg>
      返回
    </el-button>

    <el-button @click="CloseDrawer" size="medium" v-if="drawer && CourseworkForm.subject_code == 3" style="
                                                                                    position: fixed;
                                                                                    z-index: 10000;
                                                                                    float: right;
                                                                                    top: 12px;
                                                                                    right: 20px;
                                                                                    background: #66b1ff7d;
                                                                                    color: white;
                                                                                    border: 0px;
                                                                                  ">
      <svg t="1665542150306" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="2543" width="15" height="15">
        <path d="M1024 505.679012c0-10.835979-4.815991-21.069959-12.039976-27.691946l-403.941211-361.199295c-6.621987-5.417989-14.447972-9.029982-23.477954-9.029982-20.46796 0-36.721928 16.855967-36.721928 37.925926l0 159.529688C238.993533 356.985303 21.069959 591.764844 0 893.366255c1.203998 12.641975 11.437978 22.875955 23.477954 22.875955 4.815991 0 9.631981-1.805996 13.243974-4.213992 0 0 0 0 0 0 53.577895-39.129924 99.329806-68.627866 135.449735-87.891828 87.28983-49.965902 222.739565-89.697825 375.045267-105.951793l0 148.091711c0 21.069959 16.253968 37.925926 36.721928 37.925926 8.427984 0 16.253968-3.611993 22.875955-8.427984l403.941211-361.199295c0 0 0 0 0 0C1019.184009 527.35097 1024 517.11699 1024 505.679012z" p-id="2544" fill="#ffffff"></path>
        <path d="M467.151088 380.463257c-33.711934 6.019988-96.921811 24.681952-139.061728 80.667842-7.223986 9.029982-5.417989 22.875955 3.611993 30.099941 0 0 0 0 0.601999 0 9.029982 7.223986 21.671958 5.417989 28.895944-3.009994 23.477954-28.895944 51.771899-57.189888 111.971781-65.015873 9.631981-1.203998 17.457966-9.631981 17.457966-19.865961l0-3.009994C490.027043 387.687243 478.589065 378.65726 467.151088 380.463257z" p-id="2545" fill="#ffffff"></path>
        <path d="M323.273369 518.320988C322.67137 518.320988 322.67137 518.320988 323.273369 518.320988c-12.039976-6.019988-25.885949 0.601999-28.895944 12.641975-2.407995 9.631981-4.815991 19.865961-6.019988 30.70194-1.805996 12.039976 7.223986 22.875955 19.263962 22.875955l3.611993 0c10.23398 0 18.661964-7.825985 19.263962-17.457966 0.601999-7.825985 1.805996-13.243974 4.213992-24.681952C337.119342 532.768959 331.701352 522.534979 323.273369 518.320988z" p-id="2546" fill="#ffffff"></path>
      </svg>
      返回作品
    </el-button>

    <div class="school-body-index-teacher">
      <el-form @submit.native.prevent ref="form" :model="CourseworkForm" :inline="true" size="mini">
        <el-form-item label="作品名称">
          <el-input clearable style="width: 200px" v-model="CourseworkForm.title" placeholder="请输入作品名称" @keyup.enter.native="search3"></el-input>
        </el-form-item>
        <el-form-item label="班级名称">
          <el-input clearable style="width: 200px" v-model="CourseworkForm.className" placeholder="请输入班级名称" @keyup.enter.native="search3"></el-input>
        </el-form-item>
        <el-form-item label="学员姓名">
          <el-input clearable style="width: 200px" v-model="CourseworkForm.stuRealName" placeholder="请输入学员姓名" @keyup.enter.native="search3"></el-input>
        </el-form-item>

        <el-form-item size="mini">
          <el-button-group>
            <el-button size="mini" type="primary" @click="search3" icon="el-icon-search">查询
            </el-button>
            <el-button size="mini" type="primary" @click="ChangeSearchState" :icon="moresearch ? 'el-icon-caret-bottom' : 'el-icon-caret-top'"></el-button>
          </el-button-group>
        </el-form-item>

        <br />

        <el-form-item label="所属科目:" v-if="moresearch">
          <el-select v-model="CourseworkForm.subject_code" placeholder="请选择科目" style="width: 200px" filterable clearable @change="search3">
            <el-option :label="item.name" :value="item.code" v-for="(item, index) of subjectList" :key="index">
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="类型:" v-if="moresearch">
          <el-select v-model="CourseworkForm.type" placeholder="请选择" style="width: 200px" clearable @change="search3">
            <el-option label="全部" value=""></el-option>
            <el-option label="课堂" value="1"></el-option>
            <el-option label="作业" value="2"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="点评状态:" v-if="moresearch">
          <el-select v-model="CourseworkForm.is_marking" placeholder="请选择" style="width: 200px" clearable @change="search3">
            <el-option label="全部" value=""></el-option>
            <el-option label="已评价" value="1"></el-option>
            <el-option label="待评价" value="0"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="上课时间" v-if="moresearch">
          <el-date-picker @change="search3" style="width: 200px;" value-format="yyyy-MM-dd HH:mm:ss" :clearable="false" :picker-options="pickerOptions" v-model="CourseworkForm.creatTime1" type="daterange" align="right" start-placeholder="开始日期" end-placeholder="结束日期" :default-time="['00:00:00', '23:59:59']" placement="bottom-start">
          </el-date-picker>
        </el-form-item>
      </el-form>

      <el-table ref="singleTable" size="small" highlight-current-row :data="CourseWorkList" tooltip-effect="dark" :header-cell-style="{ background: '#f5f7fa', color: '#909399' }" stripe>
        <el-table-column align="center" width="50" label="序号" fixed="left">
          <template slot-scope="scope">
            <span>{{ scope.$index + 1 + (page_no3 - 1) * 20 }}</span>
          </template>
        </el-table-column>

        <el-table-column align="left" label="姓名" fixed="left" :show-overflow-tooltip="true">
          <template slot-scope="scope">
            <el-tooltip class="item" effect="dark" :content="scope.row.username" placement="top">
              <span>{{ scope.row.name }}</span>
            </el-tooltip>
          </template>
        </el-table-column>

        <el-table-column width="80" label="类型" align="left">
          <template slot-scope="scope">
            <span v-if="scope.row.work_type == '1'">课堂</span>
            <span v-else-if="scope.row.work_type == '2'">作业</span>
          </template>
        </el-table-column>

        <el-table-column align="left" label="封面" width="50">
          <template slot-scope="scope">
            <el-image style="width: 24px; height: 18px" :src="scope.row.covers" fit="cover" @click="LookOneWork(scope.row)"></el-image>
          </template>
        </el-table-column>

        <el-table-column label="作品名称" align="left">
          <template slot-scope="scope">
            <span @click="LookOneWork(scope.row)">{{ scope.row.title }}</span>
          </template>
        </el-table-column>

        <el-table-column align="left" label="老师评语" :show-overflow-tooltip="true">
          <template slot-scope="scope">
            <span v-if="scope.row.is_marking" style="color: green">{{
              scope.row.remark
            }}</span>
            <span style="color: #909399" v-else>待评价</span>
          </template>
        </el-table-column>

        <el-table-column align="left" label="星级评定" width="150">
          <template slot-scope="scope">
            <el-rate v-if="scope.row.is_marking" v-model="scope.row.markpoint" disabled>
            </el-rate>
          </template>
        </el-table-column>

        <el-table-column align="left" label="作品简介" :show-overflow-tooltip="true">
          <template slot-scope="scope">
            <span v-if="scope.row.stuTchPlanInfo.subject_id === 2 ? true : false">
              <el-link v-if="scope.row.abstract" @click="editWork(scope.row)" style="font-weight: 0; font-size: 12px">{{ scope.row.abstract }}</el-link>
              <el-link v-else @click="editWork(scope.row)" style="font-weight: 0; font-size: 12px">--</el-link>
            </span>
            <span v-else>
              <span v-if="scope.row.abstract">{{ scope.row.abstract }}</span>
              <span v-else>--</span>
            </span>
          </template>
        </el-table-column>

        <el-table-column align="left" label="操作说明" :show-overflow-tooltip="true">
          <template slot-scope="scope">
            <span v-if="scope.row.stuTchPlanInfo.subject_id === 2 ? true : false">
              <el-link v-if="scope.row.explain" @click="editWork1(scope.row)" style="font-weight: 0; font-size: 12px">
                {{ scope.row.explain }}</el-link>
              <el-link v-else @click="editWork1(scope.row)" style="font-weight: 0; font-size: 12px">--</el-link>
            </span>
            <span v-else>
              <span v-if="scope.row.explain"> {{ scope.row.explain }}</span>
              <span v-else>--</span>
            </span>
          </template>
        </el-table-column>

        <el-table-column property="created_time" label="作品提交时间" align="left" width="150"></el-table-column>
        <el-table-column property="update_time" label="更新时间" align="left" width="150"></el-table-column>
        <el-table-column align="left" label="上课时间" show-overflow-tooltip width="190">
          <template slot-scope="scope">
            <span>{{
                scope.row.stuTchPlanInfo.techPlanInfo.start_class_date.slice(
                  0,
                  16
                )
              }}
              ~
              {{
                scope.row.stuTchPlanInfo.techPlanInfo.end_class_date.slice(
                  10,
                  16
                )
              }}
            </span>
          </template>
        </el-table-column>
        <!-- <el-table-column property="created_time" label="点名时间" align="left" width="150" show-overflow-tooltip>
  
            <template slot-scope="scope">
              <span>{{ scope.row.stuTchPlanInfo.techPlanInfo.sign_date }} </span>
            </template>
          </el-table-column> -->

        <el-table-column align="left" label="家校通">
          <template slot-scope="scope">
            <span v-if="$store.state.user.schoolInfo.authorize">
              <span v-if="scope.row.authorizer_openid">
                <span v-if="scope.row.we_nickname">{{
                  scope.row.we_nickname
                }}</span>
                <span v-else>已绑定</span>
              </span>

              <el-tooltip v-else class="item" effect="dark" content="邀请家长绑定家校通,接收点评通知。" placement="top">
                <el-link @click="getQrCode(scope.row)" type="primary">绑定</el-link>
              </el-tooltip>
            </span>
            <span v-else>
              <span v-if="scope.row.openid">
                <span v-if="scope.row.we_nickname">{{
                  scope.row.we_nickname
                }}</span>
                <span v-else>已绑定</span>
              </span>

              <el-tooltip v-else class="item" effect="dark" content="邀请家长绑定家校通,接收点评通知。" placement="top">
                <el-link @click="getQrCode(scope.row)" type="primary">绑定</el-link>
              </el-tooltip>
            </span>
          </template>
        </el-table-column>

        <el-table-column align="center" label="推送状态">
          <template slot-scope="scope">
            <span v-if="scope.row.openid || scope.row.authorizer_openid">
              <span v-if="scope.row.is_send_tch_comment_wx_message"> ✔️ </span>
            </span>

            <span v-else>--</span>
          </template>
        </el-table-column>

        <el-table-column align="center" width="180" prop="name" label="操作" fixed="right">
          <template slot-scope="scope">
            <el-button v-if="scope.row.stuTchPlanInfo.subject_id == '4'" type="text" size="mini" @click="goDetails(scope.row)">查看</el-button>

            <el-button v-else type="text" size="mini" @click="LookOneWork(scope.row, scope.$index)">查看</el-button>

            <el-button type="text" size="mini" @click="MarkOneWork(scope.row)">点评</el-button>

            <el-button v-if="$store.state.user.schoolInfo.authorize" type="text" size="mini" :disabled="!scope.row.is_marking || !scope.row.authorizer_openid" @click="sendTchWorkTchCommentTemplateMessage(scope.row)">推送</el-button>
            <el-button v-else type="text" size="mini" :disabled="!scope.row.is_marking || !scope.row.openid" @click="sendTchWorkTchCommentTemplateMessage(scope.row)">推送</el-button>

            <el-button type="text" size="mini" v-if="
                scope.row.stuTchPlanInfo.subject_id == '2' ||
                  scope.row.stuTchPlanInfo.subject_id == '1'
              " @click="CreatBill(scope.row)">海报</el-button>
          </template>
        </el-table-column>
      </el-table>

      <div style="margin: 20px; text-align: right">
        <el-pagination @current-change="handleCurrentChange" :current-page="page_no3" :page-size="page_size3" layout="total, prev, pager, next, jumper" :total="total3">
        </el-pagination>
      </div>

      <!--点评PY作业弹窗-->
      <el-drawer class="comment container1" title="作品点评" :visible.sync="dialogFormVisible2" :size="widthSize" :with-header="false" :wrapperClosable="false">
        <div style="overflow: hidden; padding:20px">
          <div @click="handleClose1" style="position: relative;z-index: 6666; top: 0; right: 0px;text-align: right;">
            <i class="el-icon-close" style="font-size: 16px; cursor: pointer;"></i>
          </div>

          <div :style="{
              width:
                isShowCommonPhrases == false
                  ? '100%'
                  : 'calc(100% / 1.75 - 30px + 10px)',
            }" style="float: left; ">
            <div style="height: calc(100vh - 48px); overflow-y: auto; padding-right:20px">
              <el-form :model="markform" ref="ruleForm" label-width="200px" label-position="top" size="mini" class="demo-ruleForm">
                <el-form-item label="作品等级">
                  <el-rate style="margin-top:10px;" v-model="markform.markpoint">
                  </el-rate>
                </el-form-item>
                <el-form-item label="" prop="is_good" v-if="subject_id != 4">
                  <span style="font-weight:bold;">作品推优</span>
                  <el-switch style="margin-left:20px;" v-model="markform.is_good"></el-switch>
                </el-form-item>
                <el-form-item label="" prop="is_only" v-if="subject_id != 4">
                  <span style="font-weight:bold;">源码加密</span>
                  <el-switch style="margin-left:20px;" v-model="markform.is_only"></el-switch>
                </el-form-item>

                <el-form-item label="">
                  <span style="font-weight:bold;">教师评语</span><span style="cursor: pointer;color:#1773DC" @click="isShowCommonPhrases = true">【常用语】</span>
                  <span style="cursor: pointer;color:#1773DC" @click="generate_ai">【帮我想一段】</span>

                  <el-input style="max-height:200px;font-size:14px;" type="textarea" v-model="markform.remark" :autosize="{ minRows: 4, maxRows: 10 }"></el-input>
                </el-form-item>
              </el-form>

              <div class="demo-drawer__footer" style="text-align:right;margin-top: 20px;">
                <el-button type="primary" size="small" @click="tchSaveTchWorkScore">点 评</el-button>
                <el-button :disabled="isDisabled" type="primary" size="small" @click="all">点评并推送</el-button>
              </div>
            </div>
          </div>
          <div v-if="isShowCommonPhrases" style="width:1px;height: calc(100vh - 48px); background: #f2f2f2;float: left;margin-left: 5px; margin-right: 5px; "></div>
          <div v-if="isShowCommonPhrases" style="width:calc(100% - 100% / 1.75 + 9px);float: left; ">
            <div v-if="isShowCommonPhrases1" style="height: calc(100vh - 48px); overflow-y: auto; position: relative;">
              <div style="margin-left: 20px;">
                <div style="overflow: hidden;">
                  <div class="fl" style="font-size: 16px; margin-bottom: 10px;font-weight:bold">
                    常用语
                  </div>
                  <div @click="isShowCommonPhrases = false" class="fr" style="font-size: 16px; margin-bottom: 10px;font-weight:bold ;cursor: pointer;">
                    <i class="el-icon-close"></i>
                  </div>
                </div>
                <div v-if="tagList.length === 0">
                  <el-empty description="暂无评语"></el-empty>
                </div>
                <div v-else @click="SetComment(item.remark)" v-for="(item, index) in tagList" :key="index" style="cursor: pointer;padding: 3px;margin-bottom: 10px;border-bottom:1px solid #f2f2f2;padding-bottom: 10px;">
                  <div style="overflow: hidden; ">
                    <div class="txttag">
                      <span style="word-break: break-all;">{{
                        item.remark
                      }}</span>
                      <span class="BtnShow" style="margin-right: 10px; text-align: right; " @click.stop="editremark(item)">
                        <el-button type="text" size="mini">编辑</el-button>
                      </span>
                      <span class="BtnShow" style="margin-right: 10px; text-align: right;" @click.stop="delremark(item)">
                        <el-button type="text" size="mini">删除</el-button>
                      </span>
                    </div>
                  </div>
                </div>
              </div>
              <div style="position:fixed;right:2%;bottom:4%" @click="addremark">
                <div style="width:60px;height: 60px;border-radius: 50%;background-color:#6190F6;">
                  <div style="cursor: pointer;position:absolute;width:16px;height:16px;color:#fff;font-size:16px;top:50%;left:50%;margin-top:-8px;margin-left:-8px" class="el-icon-plus"></div>
                </div>
              </div>
            </div>
            <div v-else style="height: calc(100vh - 48px); overflow-y: auto; position: relative;">
              <el-page-header @back="goBack1" content="常用语">
              </el-page-header>
              <div style="margin-top:20px;margin-left: 20px;">
                <el-input :autosize="{ minRows: 4, maxRows: 10 }" type="textarea" placeholder="请输入常用语" v-model="remark">
                </el-input>
                <div style="margin-top:20px;overflow:hidden">
                  <!-- <el-button @click="dialogVisible5 = false">取 消</el-button> -->
                  <el-button style="float:right" type="primary" @click="sumbit5" size="mini">保 存</el-button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </el-drawer>
      <!-- <el-dialog class="comment" title="作品点评" :visible.sync="dialogFormVisible2" :close-on-click-modal="false"
                top="10vh" width="40%">
                <el-row>
                    <el-col :span="24">
                        <div>
                            <el-form :model="markform" ref="ruleForm" label-width="200px" label-position="top" size="mini"
                                class="demo-ruleForm">
                                <el-form-item label="" prop="markpoint">
                                    <span style="font-weight:bold;">作品等级</span>
                                    <el-rate style="margin-top:10px;" v-model="markform.markpoint">
                                    </el-rate>
                                </el-form-item>

                                <el-form-item label="" prop="is_good" v-if="subject_id != 4">
                                    <span style="font-weight:bold;">作品推优</span>
                                    <el-switch style="margin-left:20px;" v-model="markform.is_good"></el-switch>
                                </el-form-item>
                                <el-form-item label="" prop="is_only" v-if="subject_id != 4">
                                    <span style="font-weight:bold;">源码加密</span>
                                    <el-switch style="margin-left:20px;" v-model="markform.is_only"></el-switch>
                                </el-form-item>

                                <el-form-item label="">
                                    <span style="font-weight:bold;">教师评语</span><span style="cursor: pointer;color:#1773DC"
                                        @click="addremark">【常用语】</span>
                                    <span style="cursor: pointer;color:#1773DC" @click="generate">【帮我想一段】</span>
                                    
                                    <div>
                                        <el-tag @click="SetComment(item.remark)" v-for="(item, index) in tagList"
                                            :key="index" style="margin-right: 10px; cursor: pointer" size="mini"
                                            type="info">
                                            <div style="overflow: hidden;">
                                                <div class="txttag" style="float: left;">
                                                    <span style="margin-right: 10px; ">{{
                                                        item.remark
                                                    }}</span>
                                                </div>
                                                <div style="float: right;">
                                                    <span style="margin-right: 10px;" @click.stop="editremark(item)"><i
                                                            class="el-icon-edit"></i></span>
                                                    <span style="margin-right: 10px;" @click.stop="delremark(item)"><i
                                                            class="el-icon-delete"></i></span>
                                                </div>
                                            </div>
                                        </el-tag>
                                    </div>
                                    <el-input style="max-height:200px;font-size:14px;" type="textarea"
                                        v-model="markform.remark" :autosize="{ minRows: 4, maxRows: 10 }"></el-input>
                                </el-form-item>
                            </el-form>
                        </div>
                    </el-col>
                </el-row>

                <span slot="footer" class="dialog-footer">
                    <el-button type="primary" size="small" @click="tchSaveTchWorkScore">点 评</el-button>
                    <el-button type="primary" size="small" @click="all">点评并推送</el-button>
                </span>
            </el-dialog> -->
    </div>

    <el-drawer class="container1" :with-header="false" title="查看作品(点击右上角X号退出)" size="100%" :visible.sync="drawer" direction="ltr" :destroy-on-close="true" @close="tchGetTchStuTchWorkList">
      <iframe id="iframe_project1" width="100%" height="100%" :src="project_url"></iframe>
    </el-drawer>

    <el-dialog :title="'学员姓名:' + wx_stu_name" :visible.sync="dialogVisible1" width="260px" :before-close="handleClose">
      <div style="text-align: center; margin-top: -20px">
        <el-image style="width: 200px; height: 200px" :src="code_url" fit="fill"></el-image>
      </div>

      <div style="text-align: center">
        <span>请家长用微信扫码,绑定账号</span>
      </div>
    </el-dialog>

    <el-dialog title="作品海报" :visible.sync="dialogVisible2" width="500px" top="5vh">
      <el-row :gutter="20">
        <el-col :span="18">
          <div>
            <el-image id="myCanvas" :src="posterImg" fit="fill"></el-image>
          </div>
        </el-col>
        <el-col :span="6">
          <div class="grid-content bg-purple-light">
            <el-form size="mini" ref="form" :model="form_share" label-position="top">
              <el-form-item label="样式">
                <el-select style="width: 100px" v-model="form_share.type" placeholder="选择样式" @change="ChangeShareType">
                  <el-option label="样式一" value="1"></el-option>
                  <el-option label="样式二" value="2"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="颜色">
                <el-select style="width: 100px" v-model="form_share.color" placeholder="选择颜色" @change="ChangeShareColor">
                  <el-option label="蓝色" value="1"></el-option>
                  <el-option label="绿色" value="2"></el-option>
                  <el-option label="品红" value="3"></el-option>
                  <el-option label="红色" value="4"></el-option>
                  <el-option label="黄色" value="5"></el-option>
                </el-select>
              </el-form-item>

              <el-form-item>
                <el-button type="primary" @click="CreateShareImg" :loading="share_loading">生成海报</el-button>
              </el-form-item>
            </el-form>
          </div>
        </el-col>
      </el-row>
    </el-dialog>

    <!--分享海报页面-->
    <div id="posterHtml" v-show="false" :style="{
        backgroundImage: 'url(' + share_img + ')',
        backgroundRepeat: 'no-repeat',
        position: 'absolute',
        top: '0px',
        width: '1242px',
        height: schoolLogoUrl ? '2458px' : '2208px',
        backgroundColor:imgColorMap[form_share.color]
      }">
      <div style="position: relative; top: 740px; text-align: center">
        <span style="font-weight: bold; color: white; font-size: 80px">{{
          form_share.title
        }}</span><br />
        <span style="color: white; font-size: 50px">{{
          '作者:' + form_share.name
        }}</span>
      </div>

      <el-image style="margin-top: 765px; left: 180px; width: 902px; height: 665px" :src="form_share.cover" fit="fill">
      </el-image>

      <div id="qrcodeWorkImg" style="margin-left: 780px; margin-top: 108px"></div>
      <div class="school-logo" v-if="schoolLogoUrl" :style="{boxSizing:'content-box',position:'absolute',bottom:0,left:0,display:'flex',justifyContent:'center',alignItems:'center',width:'100%',height:'202px',padding:'25px 0',backgroundColor:imgColorMap[form_share.color]}">
        <img :src="schoolLogoUrl" alt="" style="height:100%" />
      </div>
    </div>

    <div id="posterHtml1" v-show="false" :style="{
        backgroundImage: 'url(' + share_img + ')',
        backgroundRepeat: 'no-repeat',
        position: 'absolute',
        top: '0px',
        width: '1242px',
        height: schoolLogoUrl ? '2458px' : '2208px',
        backgroundColor:imgColorMap[form_share.color]
      }">
      <el-image style="margin-top: 618px; left: 122px; width: 1004px; height: 753px" :src="form_share.cover" fit="fill">
      </el-image>

      <div style="position: relative; top: 10px; text-align: center">
        <span style="font-weight: bold; color: #333333; font-size: 60px">{{
          form_share.title
        }}</span><br />
        <span style="color: #333333; font-size: 40px">{{
          '作者:' + form_share.name
        }}</span>
      </div>

      <div style="margin-left: 230px; margin-top: 33px; color: #f7ba2a">
        <i v-for="count in form_share.star_num" :key="count" class="el-icon-star-on" style="font-size: 100px; margin: 10px">
        </i>
      </div>

      <div v-if="form_share.star_num" id="qrcodeWorkImg1" style="margin-left: 135px; margin-top: 212px"></div>
      <div v-else id="qrcodeWorkImg1" style="margin-left: 135px; margin-top: 365px"></div>
      <div class="school-logo" v-if="schoolLogoUrl" :style="{boxSizing:'content-box',position:'absolute',bottom:0,left:0,display:'flex',justifyContent:'center',alignItems:'center',width:'100%',height:'202px',padding:'25px 0',backgroundColor:imgColorMap[form_share.color]}">
        <img :src="schoolLogoUrl" alt="" style="height:100%" />
      </div>
    </div>
    <!-- 编辑作品简介 -->
    <el-dialog title="编辑作品简介" :visible.sync="dialogVisible3">
      <el-input type="textarea" :rows="2" placeholder="请输入内容" v-model="textarea">
      </el-input>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible3 = false">取 消</el-button>
        <el-button type="primary" @click="sumbit1">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 编辑操作说明 -->
    <el-dialog title="编辑操作说明" :visible.sync="dialogVisible4">
      <el-input type="textarea" :rows="2" placeholder="请输入内容" v-model="textarea1">
      </el-input>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible4 = false">取 消</el-button>
        <el-button type="primary" @click="sumbit2">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 自定义 -->
    <el-dialog title="常用语" :visible.sync="dialogVisible5">
      <el-input type="textarea" placeholder="请输入常用语" v-model="remark">
      </el-input>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible5 = false">取 消</el-button>
        <el-button type="primary" @click="sumbit5">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {
  getTchClasslist,
  tchGetTchTimetable,
  tchGetStuTchPlanListByTchId,
  tchSaveTchWorkScore,
  tchGetTchStuTchWorkList,
  tchWorkSelfRemarkCreateOrUpdate,
  tchWorkSelfRemarkGet,
  tchWorkSelfRemarkDelete,
} from '@/api/classroom/teacher_api'

import { dateFormat } from '@/config/_filter'
import {
  getBaseInfo,
  getSchoolSubjectList,
  sendTchWorkTchCommentTemplateMessage,
  updateTchPlanSignState,
  getQrCode,
  tchSaveTchWorkInfo,
  getPrepareCurrculumMaterial,
  getGhatGptToken,
} from '@/api/educational.js'
import QRCode from 'qrcodejs2' // 引入qrcode
import html2canvas from 'html2canvas'
import moment from 'moment'

import driverStep from '@/utils/guide/classlist_index_teacher'

export default {
  name: 'works',
  data() {
    return {
      isDisabled: false,
      isShowCommonPhrases: false,
      isShowCommonPhrases1: true,
      widthSize: '40%',
      remark_id: '',
      dialogVisible5: false,
      remark: '',
      tableRow: null,
      textarea1: '',
      dialogVisible4: false,
      tch_work_id1: '',
      textarea: '',
      dialogVisible3: false,
      subject_id: '',
      //日期快捷选择
      //日期快捷选择
      pickerOptions: {
        shortcuts: [
          {
            text: '今日',
            onClick(picker) {
              const start = moment().format('YYYY-MM-DD 00:00:00')
              const end = moment().format('YYYY-MM-DD 23:59:59')
              picker.$emit('pick', [start, end])
            },
          },
          {
            text: '近一周',
            onClick(picker) {
              const start = moment()
                .day(moment().day() - 6)
                .format('YYYY-MM-DD 00:00:00')
              const end = moment().format('YYYY-MM-DD 23:59:59')
              console.log(start, 1234165)
              console.log(end, 1234165)

              picker.$emit('pick', [start, end])
            },
          },

          {
            text: '近一个月',
            onClick(picker) {
              const start = moment()
                .subtract(1, 'months')
                .format('YYYY-MM-DD 00:00:00')
              const end = moment().format('YYYY-MM-DD 23:59:59')

              picker.$emit('pick', [start, end])
            },
          },
          {
            text: '近三个月',
            onClick(picker) {
              const start = moment()
                .subtract(3, 'months')
                .format('YYYY-MM-DD 00:00:00')
              const end = moment().format('YYYY-MM-DD 23:59:59')
              picker.$emit('pick', [start, end])
            },
          },
          // {
          //   text: "本季度",
          //   onClick(picker) {
          //     const start = moment(moment().quarter(moment().quarter()).startOf('quarter').valueOf()).format('YYYY-MM-DD 00:00:00');
          //     const end = moment(moment().quarter(moment().quarter()).endOf('quarter').valueOf()).format('YYYY-MM-DD 23:59:59');
          //     picker.$emit("pick", [start, end]);
          //   },
          // },
          // {
          //   text: "上季度",
          //   onClick(picker) {
          //     const start = moment(moment().quarter(moment().quarter() - 1).startOf('quarter').valueOf()).format('YYYY-MM-DD 00:00:00');
          //     const end = moment(moment().quarter(moment().quarter() - 1).endOf('quarter').valueOf()).format('YYYY-MM-DD 23:59:59');
          //     picker.$emit("pick", [start, end]);
          //   },
          // },
          {
            text: '近一年',
            onClick(picker) {
              const start = moment()
                .subtract(1, 'years')
                .format('YYYY-MM-DD 00:00:00')
              const end = moment().format('YYYY-MM-DD 23:59:59')
              picker.$emit('pick', [start, end])
            },
          },
          {
            text: '去年',
            onClick(picker) {
              const start = moment(
                moment()
                  .year(moment().year() - 1)
                  .startOf('year')
                  .valueOf()
              ).format('YYYY-MM-DD 00:00:00')
              const end = moment(
                moment()
                  .year(moment().year() - 1)
                  .endOf('year')
                  .valueOf()
              ).format('YYYY-MM-DD 23:59:59')
              picker.$emit('pick', [start, end])
            },
          },
        ],
      },

      userSubject: [],
      classList: [],
      currentpage: 1,

      sizeForm: {
        classname: '',
        subject_id: '', //科目
        teaching_type: '', //课程类型
        course_week: '', //上课日期
        course_state: '', //班级状态
        course_time: '', //授课时段
        end_class_state: '0',
      },
      activeName: 'first',

      //老师课表分页
      page_no: 1,
      page_size: 10,
      total: 0,

      //班级列表分页
      page_no2: 1,
      page_size2: 12,
      total2: 0,

      //作业点评分页
      page_no3: 1,
      page_size3: 20,
      total3: 0,

      teaching_plan_list: [], //老师讲次类表
      CourseWork: [], //学员提交的作品
      markform: {
        markpoint: '',
        remark: '',
        is_good: false,
        is_only: false,
      }, //作品点评

      work_title: '', //项目名称
      work_url: '', //项目地址
      workinfo: {}, //预览的项目信息
      StuInfo: {},
      stu_name: '',
      dialogFormVisible2: false,
      tch_work_id: '',

      course_time: [],
      moresearch: true,

      teachplan_form: {
        date: [],
        sign_state: '',
        latest: true,
        default_time: '',
      },
      dialogVisible: false,
      dialogVisible2: false, //分享海报窗口
      subjectList: [], //校区科目列表
      CourseworkForm: {
        creatTime1: [],
        subject_code: '',
        is_marking: '',
        type: '',
      },

      subject_code: '',

      //作品尺寸适配
      frameWidth: 0, // 屏幕宽
      frameHeight: 0, // 屏幕高
      scale: 0,

      //JRCODE作品点评
      frameWidth1: 0, // 屏幕宽
      frameHeight1: 0, // 屏幕高

      //PYTHON作品点评
      frameWidth2: 0, // 屏幕宽
      frameHeight2: 0, // 屏幕高
      python_work_url: '',

      drawer: false,
      direction: 'rtl',
      project_url: '',
      CourseWorkList: [],

      //绑定微信二维码
      dialogVisible1: false,
      code_url: '',
      wx_stu_name: '',

      //生成海报
      posterContent: '很不错', // 文案内容
      posterHtmlBg:
        'https://wugecdn.steam.fun/courses/b_scratch_course/bb_general_course/version2.0/poster/09%E5%B0%8F%E5%BF%83%E9%9B%AA%E5%B4%A9.png', // 背景图
      posterImg: '', // 最终生成的海报图片

      share_img: '', //默认海报
      share_type: '1', //海报类型

      form_share: {
        work_id: '',
        type: '1',
        color: '1',
        cover: '',
        title: '',
        name: '',
        star_num: 0,
        images1: [
          'https://wugecdn.steam.fun/resources/static/work_share/bg_blue_1.png',
          'https://wugecdn.steam.fun/resources/static/work_share/bg_green_1.png',
          'https://wugecdn.steam.fun/resources/static/work_share/bg_pink_1.png',
          'https://wugecdn.steam.fun/resources/static/work_share/bg_red_1.png',
          'https://wugecdn.steam.fun/resources/static/work_share/bg_yellow_1.png',
        ],
        images2: [
          'https://wugecdn.steam.fun/resources/static/work_share/bg_blue_2.png',
          'https://wugecdn.steam.fun/resources/static/work_share/bg_green_2.png',
          'https://wugecdn.steam.fun/resources/static/work_share/bg_pink_2.png',
          'https://wugecdn.steam.fun/resources/static/work_share/bg_red_2.png',
          'https://wugecdn.steam.fun/resources/static/work_share/bg_yellow_2.png',
        ],
        stuTchPlanIdTest: '',
        schoolIdTest: ''
      },
      share_loading: false, //生成海报加载

      //首页快捷跳转
      active: '', //跳转目标
      stuId1: {},
      tagList: [],

      //chatgpt配置
      loading: false,
      streamCache: '',
      messages: [],
      auto_comment: '',
      subjectname: '',
      request_info: '',
      api_key: '',
      schoolLogoUrl: '',
      imgColorMap: {
        1: '#2EB3FF',
        2: '#35B72A',
        3: '#FF63B1',
        4: '#FF5B5C',
        5: '#FFBD4A',
      },
    }
  },
  watch: {
    isShowCommonPhrases(val) {
      if (val === false) {
        this.widthSize = '40%'
      } else {
        this.widthSize = '70%'
      }
    },
    dialogFormVisible2(val) {
      if (val === false) {
        this.isShowCommonPhrases = false
      }
    },
  },
  created() {
    this.getSchoolSubjectList()
    this.getBaseInfo()
  },
  destroyed() {
    localStorage.setItem('home_template_url', '')
  },

  mounted() {
    const startDate = moment()
      .subtract(1, 'months')
      .format('YYYY-MM-DD 00:00:00')
    const endDate = moment().format('YYYY-MM-DD 23:59:59')

    this.CourseworkForm.creatTime1.push(startDate, endDate)
    console.log(startDate, 789465)
    console.log(endDate, 789465)
    this.frameWidth = document.documentElement.clientWidth * 0.8 * 0.583 - 50
    this.frameHeight = this.frameWidth * 0.75 + 55

    this.frameWidth1 = document.documentElement.clientWidth * 0.8 - 50
    this.frameHeight1 = this.frameWidth1 * 0.5 + 55

    this.frameWidth2 = document.documentElement.clientWidth * 0.8 - 50
    this.frameHeight2 = this.frameWidth1 * 0.5 + 55

    this.scale = this.frameWidth / 480

    this.teachplan_form.default_time = dateFormat() //默认查今天往后的课程

    this.activeName = this.$route.query.active
      ? this.$route.query.active
      : 'first'

    this.tchGetTchTimetable()
    this.tchWorkSelfRemarkGet()
    const schoolInfo = JSON.parse(sessionStorage.getItem('schoolInfo'))
    if (schoolInfo) {
      this.schoolLogoUrl = schoolInfo.homepageData.homepage.logo_img_url
    }
  },

  methods: {
    //动态获得GPT-TOKEN
    getGhatGptToken() {
      getGhatGptToken().then((res) => {
        console.log('动态获取GPT')
        console.log(res.chatGptKeyList)
        localStorage.setItem('gpt_token', res.chatGptKeyList[0].key)
      })
    },

    handleClose1() {
      this.dialogFormVisible2 = false
    },

    async generate_ai() {
      console.log('新的Ai服务器')

      this.subjectname = ''
      this.request_info = ''

      if (this.workinfo.stuTchPlanInfo.subject_id == 1) {
        console.log('Jrcode')
        this.subjectname = 'Jrcode'
      } else if (this.workinfo.stuTchPlanInfo.subject_id == 2) {
        console.log('Scratch')
        this.subjectname = 'Scratch'
      } else if (this.workinfo.stuTchPlanInfo.subject_id == 3) {
        console.log('Python')
        this.subjectname = 'Python'
      } else if (this.workinfo.stuTchPlanInfo.subject_id == 4) {
        console.log('C++')
        this.subjectname = 'C++'
      } else {
        console.log('其他科目')
        this.subjectname = '机器人'
      }

      this.request_info =
        '你是一个少儿编程老师，以第一人称给我的学员"' +
        this.workinfo.name +
        '"写一段50字以内的课堂评价，包含3条优点、1条改进的点，学习的科目是' +
        this.subjectname

      this.streamCache = ''
      this.loading = true

      fetch('https://ai.wugedianxia.cn/api/chat/completions', {
        method: 'POST',
        body: JSON.stringify({
          text: this.request_info,
          //sessionId: 894,
          appId: 58,
        }),
        headers: {
          'Content-Type': 'application/json',
          Authorization: localStorage.getItem('gpt_token'),
        },
      }).then((res) => {
        console.log('新人工智能服务器返回')
        console.log(res)

        const reader = res.body.getReader()
        const decoder = new TextDecoder('utf-8')

        let that = this
        reader.read().then(async function processText(res) {
          //console.log("循环读取信息");
          //console.log(res);

          if (res.done || !that.loading) {
            return
          }

          const decodeContent = decoder.decode(res.value)

          //console.log("decodeContent");
          //console.log(decodeContent);

          // error
          if (decodeContent.includes(`"error": {\n`)) {
            console.log('账户错误')
            console.log(decodeContent)
            that.loading = false
            return
          }

          // done
          if (decodeContent.includes('data: [DONE]')) {
            that.loading = false
            console.log('回答完成')
            return
          }

          decodeContent
            .replaceAll('data: ', '')
            .split('\n')
            .filter(Boolean)
            .forEach(async (item) => {
              const itemObj = JSON.parse(item)

              console.log('新服务器回答')
              console.log(itemObj)

              if (!itemObj.data) {
                return
              }

              const str = itemObj.data

              that.streamCache += str

              that.markform.remark += str
            })

          return reader.read().then(processText)
        })
      })
    },

    delremark(row) {
      this.$confirm('是否确认删除?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          tchWorkSelfRemarkDelete({
            remark_id: row.id,
          }).then(() => {
            this.$message({
              type: 'success',
              message: '删除成功!',
            })
            this.tchWorkSelfRemarkGet()
          })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除',
          })
        })
    },
    sumbit5() {
      if (this.remark_id === '') {
        tchWorkSelfRemarkCreateOrUpdate({
          remark: this.remark,
        }).then((res) => {
          console.log(res)
          this.$message.success('添加成功')
          // this.dialogVisible5 = false;
          this.isShowCommonPhrases1 = true

          this.tchWorkSelfRemarkGet()
        })
      } else {
        tchWorkSelfRemarkCreateOrUpdate({
          remark: this.remark,
          remark_id: this.remark_id,
        }).then((res) => {
          console.log(res)
          this.$message.success('编辑成功')
          // this.dialogVisible5 = false;
          this.isShowCommonPhrases1 = true

          this.tchWorkSelfRemarkGet()
        })
      }
    },
    tchWorkSelfRemarkGet() {
      tchWorkSelfRemarkGet({}).then((res) => {
        console.log(res, 12121452)
        this.tagList = res.tchWorkSelfRemarkList
      })
    },
    editremark(row) {
      this.remark_id = row.id
      this.remark = row.remark
      this.isShowCommonPhrases1 = false

      // this.dialogVisible5 = true;
    },
    goBack1() {
      this.isShowCommonPhrases1 = true
    },
    addremark() {
      // this.remark = ''
      this.remark_id = ''
      this.remark = ''
      this.isShowCommonPhrases1 = false

      // this.dialogVisible5 = true;
    },
    CloseDrawer() {
      console.log('返回作品列表')

      this.$confirm('确定要返回吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        this.drawer = false
      })
    },

    //查看学生作品
    //教师查看学生作品
    goDetails(row) {
      this.cpp_url =
        '/cpp?' +
        '&lesson_id=' +
        row.stuTchPlanInfo.techPlanInfo.curriculum_meterial_id +
        '&stu_id=' +
        row.stu_user_id +
        '&type=' +
        row.work_type +
        '&userType=' +
        'stu' +
        '&comment=' +
        'tchComment'
      sessionStorage.setItem('lecturesTitle', row.title)
      sessionStorage.setItem('sbj', '4')

      window.open(this.cpp_url, '_blank')
    },
    //编辑作品简介
    editWork1(row) {
      console.log(row)
      this.tch_work_id1 = row.id
      this.textarea1 = row.explain
      this.dialogVisible4 = true
    },
    sumbit2() {
      tchSaveTchWorkInfo({
        tch_work_id: this.tch_work_id1,
        explain: this.textarea1,
        subject_code: 2,
      }).then(() => {
        this.$message.success('修改成功!')
        this.tchGetTchStuTchWorkList()
        this.dialogVisible4 = false
      })
    },
    //编辑作品简介
    editWork(row) {
      console.log(row)
      this.tch_work_id1 = row.id
      this.textarea = row.abstract
      this.dialogVisible3 = true
    },
    sumbit1() {
      tchSaveTchWorkInfo({
        tch_work_id: this.tch_work_id1,
        abstract: this.textarea,
        subject_code: 2,
      }).then(() => {
        this.$message.success('修改成功!')
        this.tchGetTchStuTchWorkList()
        this.dialogVisible3 = false
      })
    },

    all() {
      // this.tchSaveTchWorkScore();
      if (!this.markform.markpoint) {
        this.$message.warning('请对作品等级进行评价!')
        return
      } else {
        tchSaveTchWorkScore({
          subject_code: this.subject_id,
          tch_work_id: this.tch_work_id,
          markpoint: this.markform.markpoint,
          remark: this.markform.remark,
          is_good: this.markform.is_good,
          is_only: this.markform.is_only,
        }).then((res) => {
          console.log('教师点评作品')
          console.log(res)
          if (res.is_update) {
            this.$message.success('点评成功')
            this.dialogFormVisible2 = false
            this.tchGetTchStuTchWorkList()
          }
        })
        this.$confirm('即将把作品推送至家长微信,是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        }).then(() => {
          if (this.stuId1.is_send_tch_comment_wx_message) {
            this.$confirm('已推送过点评消息,是否再次推送?', '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning',
            }).then(() => {
              var to_url = ''
              var remark = ''
              if (this.CourseworkForm.subject_code == '1') {
                to_url =
                  'https://steam.fun/jrcode/h5show.html?mode=look&filepath=' +
                  this.stuId1.work_url
                remark = '无'
              } else if (this.CourseworkForm.subject_code == '2') {
                to_url =
                  'https://steam.fun/scratch/h5player.html?work_type=2&work_id=' +
                  this.stuId1.id +
                  '&subject_code=2' + `&stuTchPlanIdTest=${this.form_share.stuTchPlanIdTest}&schoolIdTest=${this.form_share.schoolIdTest}`
                remark = '点击详情,立即体验!'
              } else if (this.CourseworkForm.subject_code == '3') {
                to_url = ''
                remark = '无'
              }

              sendTchWorkTchCommentTemplateMessage({
                tch_work_id: this.stuId1.id,
                subject_code: this.CourseworkForm.subject_code,
                to_url: to_url,
                remark: remark,
              }).then((res) => {
                console.log('推送通知')
                console.log(res)
                if (res.is_send) {
                  console.log('发送成功')
                  this.$message.success('点评已推送至家长微信')
                  this.tchGetTchStuTchWorkList()
                } else {
                  this.$message.warning(res.msg)
                }
              })
            })
          } else {
            var to_url = ''
            var remark = ''
            if (this.CourseworkForm.subject_code == '1') {
              to_url =
                'https://steam.fun/jrcode/h5show.html?mode=look&filepath=' +
                this.stuId1.work_url
              remark = '无'
            } else if (this.CourseworkForm.subject_code == '2') {
              to_url =
                'https://steam.fun/scratch/h5player.html?work_type=2&work_id=' +
                this.stuId1.id +
                '&subject_code=2' + `&stuTchPlanIdTest=${this.form_share.stuTchPlanIdTest}&schoolIdTest=${this.form_share.schoolIdTest}`
              remark = '点击详情,立即体验!'
            } else if (this.CourseworkForm.subject_code == '3') {
              to_url = ''
              remark = '无'
            }

            sendTchWorkTchCommentTemplateMessage({
              tch_work_id: this.stuId1.id,
              subject_code: this.CourseworkForm.subject_code,
              to_url: to_url,
              remark: remark,
            }).then((res) => {
              console.log('推送通知')
              console.log(res)
              if (res.is_send) {
                console.log('发送成功')
                this.$message.success('点评已推送至家长微信')
                this.tchGetTchStuTchWorkList()
              } else {
                this.$message.warning(res.msg)
              }
            })
          }
        })
      }

      console.log('推送通知')
    },
    start() {
      this.$nextTick(() => {
        this.$driver.defineSteps(driverStep)
        this.$driver.start()
      })
    },

    compileStr(code) {
      //对字符串进行加密
      var c = String.fromCharCode(code.charCodeAt(0) + code.length)
      for (var i = 1; i < code.length; i++) {
        c += String.fromCharCode(code.charCodeAt(i) + code.charCodeAt(i - 1))
      }
      return escape(c)
    },

    //字符串进行解密
    uncompileStr(code) {
      code = unescape(code)
      var c = String.fromCharCode(code.charCodeAt(0) - code.length)
      for (var i = 1; i < code.length; i++) {
        c += String.fromCharCode(code.charCodeAt(i) - c.charCodeAt(i - 1))
      }
      return c
    },

    handleClickTab() {
      if (this.activeName == 'first') {
        console.log('点击我的课表')
        this.tchGetTchTimetable()
      } else if (this.activeName == 'second') {
        console.log('点击我的班级')
        this.getTchClasslist()
      } else if (this.activeName == 'third') {
        console.log('点击作品点评')
        this.tchGetTchStuTchWorkList()
      }
    },

    LatestCourse(e) {
      if (e.target.tagName === 'INPUT') return // 因为原生click事件会执行两次，第一次在label标签上，第二次在input标签上，故此处理

      console.log('最近课程')
      console.log(this.teachplan_form.latest)

      if (!this.teachplan_form.latest) {
        this.teachplan_form.default_time = dateFormat() //获得当前时间
        this.teachplan_form.date = []
      } else {
        this.teachplan_form.default_time = ''
      }
      this.page_no = 1
      this.tchGetTchTimetable()
      console.log(this.teachplan_form.default_time)
    },

    handleCurrentChange(val) {
      this.page_no3 = val
      this.tchGetTchStuTchWorkList()
    },

    //获取学校科目权限列表
    getSchoolSubjectList() {
      console.log('校区ID')
      console.log(this.campusId)
      getSchoolSubjectList().then((res) => {
        this.subjectList = res.subjectList
        console.log('获取学校科目权限列表')
        console.log(res)

        if (res.subjectList.length == 0) {
          this.$message.warning('无科目权限')
          return
        }
        this.CourseworkForm.subject_code = res.subjectList[0].code

        this.tchGetTchStuTchWorkList()
      })
    },

    CreatBill(row) {
      console.log('生成海报')
      console.log(row)
      this.dialogVisible2 = true
      this.form_share.cover = row.covers
      this.form_share.work_id = row.id
      this.form_share.title = row.title
      this.form_share.name = row.name
      this.form_share.star_num = row.markpoint

      this.form_share.subject_id = row.stuTchPlanInfo.subject_id
      this.work_url = row.work_url
      this.form_share.stuTchPlanIdTest = row.stuTchPlanInfo.id
      this.form_share.schoolIdTest = row.stuTchPlanInfo.educational_institution_id

      if (this.form_share.type == '1') {
        if (this.form_share.color == '1') {
          this.posterImg = this.form_share.images1[0]
        } else if (this.form_share.color == '2') {
          this.posterImg = this.form_share.images1[1]
        } else if (this.form_share.color == '3') {
          this.posterImg = this.form_share.images1[2]
        } else if (this.form_share.color == '4') {
          this.posterImg = this.form_share.images1[3]
        } else if (this.form_share.color == '5') {
          this.posterImg = this.form_share.images1[4]
        }

        if (row.stuTchPlanInfo.subject_id == '1') {
          console.log('Jrcode海报1')
          this.qrcode_work_jr(row.work_url)
        } else if (row.stuTchPlanInfo.subject_id == '2') {
          console.log('Scratch海报')
          this.qrcode_work()
        }
      } else if (this.form_share.type == '2') {
        if (this.form_share.color == '1') {
          this.posterImg = this.form_share.images2[0]
        } else if (this.form_share.color == '2') {
          this.posterImg = this.form_share.images2[1]
        } else if (this.form_share.color == '3') {
          this.posterImg = this.form_share.images2[2]
        } else if (this.form_share.color == '4') {
          this.posterImg = this.form_share.images2[3]
        } else if (this.form_share.color == '5') {
          this.posterImg = this.form_share.images2[4]
        }
        if (row.stuTchPlanInfo.subject_id == '1') {
          console.log('Jrcode海报2')
          this.qrcode_work_jr1(row.work_url)
        } else if (row.stuTchPlanInfo.subject_id == '2') {
          console.log('Scratch海报')
          this.qrcode_work1()
        }
      }

      this.share_img = this.posterImg
    },

    CreateShareImg() {
      this.share_loading = true

      // 生成海报
      const vm = this

      if (this.form_share.type == '1') {
        const domObj = document.getElementById('posterHtml')
        console.log('分享海报-样式一')
        console.log(domObj)
        html2canvas(domObj, {
          useCORS: true,
          allowTaint: false,
          logging: false,
          letterRendering: true,
          onclone(doc) {
            let e = doc.querySelector('#posterHtml')
            e.style.display = 'block'
          },
        }).then(function (canvas) {
          // 在微信里,可长按保存或转发
          vm.posterImg = canvas.toDataURL('image/png')
          console.log('生成的海报')
          console.log(canvas)
          console.log(vm.posterImg)
          vm.share_loading = false
          vm.$confirm('海报已生成,是否下载?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'success',
          }).then(() => {
            vm.DownloadImage()
          })
        })
      } else if (this.form_share.type == '2') {
        const domObj = document.getElementById('posterHtml1')
        console.log('分享海报-样式二')
        console.log(domObj)
        html2canvas(domObj, {
          useCORS: true,
          allowTaint: false,
          logging: false,
          letterRendering: true,
          onclone(doc) {
            let e = doc.querySelector('#posterHtml1')
            e.style.display = 'block'
          },
        }).then(function (canvas) {
          // 在微信里,可长按保存或转发
          vm.posterImg = canvas.toDataURL('image/png')
          console.log('生成的海报')
          console.log(canvas)
          console.log(vm.posterImg)
          vm.share_loading = false
          vm.$confirm('海报已生成,是否下载?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'success',
          }).then(() => {
            vm.DownloadImage()
          })
        })
      }
    },

    ChangeShareType() {
      console.log('更换海报样式')
      console.log(this.form_share.type)
      if (this.form_share.type == '1') {
        if (this.form_share.color == '1') {
          this.posterImg = this.form_share.images1[0]
        } else if (this.form_share.color == '2') {
          this.posterImg = this.form_share.images1[1]
        } else if (this.form_share.color == '3') {
          this.posterImg = this.form_share.images1[2]
        } else if (this.form_share.color == '4') {
          this.posterImg = this.form_share.images1[3]
        } else if (this.form_share.color == '5') {
          this.posterImg = this.form_share.images1[4]
        }

        if (this.form_share.subject_id == '1') {
          this.qrcode_work_jr(this.work_url)
        } else if (this.form_share.subject_id == '2') {
          this.qrcode_work()
        }
      } else if (this.form_share.type == '2') {
        if (this.form_share.color == '1') {
          this.posterImg = this.form_share.images2[0]
        } else if (this.form_share.color == '2') {
          this.posterImg = this.form_share.images2[1]
        } else if (this.form_share.color == '3') {
          this.posterImg = this.form_share.images2[2]
        } else if (this.form_share.color == '4') {
          this.posterImg = this.form_share.images2[3]
        } else if (this.form_share.color == '5') {
          this.posterImg = this.form_share.images2[4]
        }

        if (this.form_share.subject_id == '1') {
          this.qrcode_work_jr1(this.work_url)
        } else if (this.form_share.subject_id == '2') {
          this.qrcode_work1()
        }
      }

      this.share_img = this.posterImg
    },

    ChangeShareColor() {
      console.log('更换海报颜色')
      console.log(this.form_share.color)

      if (this.form_share.type == '1') {
        if (this.form_share.color == '1') {
          this.posterImg = this.form_share.images1[0]
        } else if (this.form_share.color == '2') {
          this.posterImg = this.form_share.images1[1]
        } else if (this.form_share.color == '3') {
          this.posterImg = this.form_share.images1[2]
        } else if (this.form_share.color == '4') {
          this.posterImg = this.form_share.images1[3]
        } else if (this.form_share.color == '5') {
          this.posterImg = this.form_share.images1[4]
        }
      } else if (this.form_share.type == '2') {
        if (this.form_share.color == '1') {
          this.posterImg = this.form_share.images2[0]
        } else if (this.form_share.color == '2') {
          this.posterImg = this.form_share.images2[1]
        } else if (this.form_share.color == '3') {
          this.posterImg = this.form_share.images2[2]
        } else if (this.form_share.color == '4') {
          this.posterImg = this.form_share.images2[3]
        } else if (this.form_share.color == '5') {
          this.posterImg = this.form_share.images2[4]
        }
      }

      this.share_img = this.posterImg
    },

    qrcode_work() {
      document.getElementById('qrcodeWorkImg').innerHTML = ''
      new QRCode('qrcodeWorkImg', {
        width: 365,
        height: 365,
        text:
          'https://steam.fun/scratch/h5player.html?work_type=2&work_id=' +
          this.form_share.work_id +
          '&subject_code=2' + `&stuTchPlanIdTest=${this.form_share.stuTchPlanIdTest}&schoolIdTest=${this.form_share.schoolIdTest}`, // 二维码地址
        colorDark: '#000',
        colorLight: '#fff',
      })
    },

    qrcode_work_jr(work_url) {
      document.getElementById('qrcodeWorkImg').innerHTML = ''
      new QRCode('qrcodeWorkImg', {
        width: 365,
        height: 365,
        text:
          'https://steam.fun/jrcode/h5show.html?mode=look&filepath=' + work_url,
        colorDark: '#000',
        colorLight: '#fff',
        correctLevel: 3,
      })
    },

    qrcode_work1() {
      document.getElementById('qrcodeWorkImg1').innerHTML = ''
      new QRCode('qrcodeWorkImg1', {
        width: 240,
        height: 240,
        text:
          'https://steam.fun/scratch/h5player.html?work_type=2&work_id=' +
          this.form_share.work_id +
          '&subject_code=2' + `&stuTchPlanIdTest=${this.form_share.stuTchPlanIdTest}&schoolIdTest=${this.form_share.schoolIdTest}`, // 二维码地址
        colorDark: '#000',
        colorLight: '#fff',
      })
    },

    qrcode_work_jr1(work_url) {
      console.log('Jrcode 作品地址1')
      console.log(work_url)

      document.getElementById('qrcodeWorkImg1').innerHTML = ''
      new QRCode('qrcodeWorkImg1', {
        width: 240,
        height: 240,
        text:
          'https://steam.fun/jrcode/h5show.html?mode=look&filepath=' + work_url,
        colorDark: '#000',
        colorLight: '#fff',
        correctLevel: 3,
      })
    },

    DownloadImage() {
      console.log('下载分享海报')
      console.log(this.posterImg)
      // 如果浏览器支持msSaveOrOpenBlob方法（也就是使用IE浏览器的时候），那么调用该方法去下载图片
      if (window.navigator.msSaveOrOpenBlob) {
        const bstr = atob(this.posterImg.split(',')[1])
        let n = bstr.length
        const u8arr = new Uint8Array(n)
        while (n--) {
          u8arr[n] = bstr.charCodeAt(n)
        }
        const blob = new Blob([u8arr])
        // window.navigator.msSaveOrOpenBlob(blob, "chart-download" + "." + "png");
        window.navigator.msSaveOrOpenBlob(
          blob,
          `${this.form_share.title}-${this.form_share.name}.png`
        )
      } else {
        // 这里就按照chrome等新版浏览器来处理
        const a = document.createElement('a')
        a.href = this.posterImg
        a.setAttribute(
          'download',
          `${this.form_share.title}-${this.form_share.name}`
        )
        a.click()
      }
    },

    //改变搜索条件
    ChangeSearchState() {
      this.moresearch = !this.moresearch
    },

    //查询校区上课时段

    getBaseInfo() {
      getBaseInfo().then((res) => {
        console.log('校区授课时段')
        console.log(res)
        this.course_time = res.educational_institution_class_day_list
      })
    },

    //查询班级列表
    getTchClasslist() {
      console.log('班级状态')
      console.log(this.sizeForm.course_state)

      getTchClasslist({
        subject_id: this.sizeForm.subject_id,
        teaching_type: this.sizeForm.teaching_type,
        course_state: this.sizeForm.course_state,
        course_week: this.sizeForm.course_week,
        course_time: this.sizeForm.course_time,
        end_class_state: this.sizeForm.end_class_state,
        name: this.sizeForm.classname,
        page_no: this.page_no2,
        page_size: this.page_size2,
      }).then((res) => {
        console.log('获取班级列表')
        console.log(res)
        this.total2 = res.classlist_total

        this.userSubject = res.userSubject //用户科目
        this.classList = res.classlist //班级列表
      })
    },

    //根据讲次查询学员课堂作品和学员课后作业完成情况
    tchGetStuTchPlanListByTchId(tch_plan_id) {
      console.log('讲次相关作品查询')
      console.log(tch_plan_id)

      tchGetStuTchPlanListByTchId({
        tch_plan_id: tch_plan_id,
      }).then((res) => {
        console.log('查询讲次的课堂作品和作业作品')
        console.log(res)
        this.CourseWork = res.stuTchPlanList
      })
    },

    //作品打分
    MarkWork(id, workinfo, stuinfo, subjectinfo) {
      this.work_title = workinfo.title
      this.work_url = workinfo.work_url
      this.workinfo = workinfo
      this.StuInfo = stuinfo
      this.stu_name = stuinfo.studentUserInfo.realname
      this.tch_work_id = workinfo.id

      this.subject_code = subjectinfo.code

      //课表页面查看修改学员课堂作品

      if (workinfo.is_marking) {
        this.markform = {
          is_good: workinfo.is_good,
          is_only: workinfo.is_only,
          markpoint: workinfo.markpoint,
          remark: workinfo.remark,
        }
      } else {
        this.markform = {
          is_good: false,
          is_only: false,
          markpoint: '',
          remark: '',
        }
      }

      console.log(id)
      console.log('workinfo')
      console.log(this.workinfo)
      console.log('stuinfo')
      console.log(this.StuInfo)
      console.log('subject_code')
      console.log(this.subject_code)

      if (this.subject_code == '1') {
        this.project_url =
          '/jrcode/teachjr.html?mode=edit&filepath=' +
          this.work_url +
          '&mode=edit'
        this.drawer = true
      } else if (this.subject_code == '2') {
        console.log('SC作品查看')
        this.project_url =
          '/scratch/teachsc.html?workurl=' +
          this.compileStr(this.work_url).replace(/%/g, '%25') +
          '&workname=' +
          this.work_title +
          '&type=2'
        this.drawer = true
      } else if (this.subject_code == '3') {
        this.project_url = '/python/teachpy?type=3&title=' + this.work_title
        this.$store.commit(
          'SET_TEACH_TEMPLATE_URL',
          this.workinfo.work_url || ''
        )
        this.drawer = true
      }
    },
    //设置评语
    SetComment(val) {
      console.log(val)
      this.markform.remark = this.markform.remark + val
    },

    LookOneWork(row, index) {
      console.log(index, 1245)
      this.tableRow = index
      console.log(this.tableRow, 1245)
      console.log(row, 123456)

      console.log('查看11个作品')
      console.log(row)

      this.work_title = row.title
      this.work_url = row.work_url
      this.workinfo = row
      // this.StuInfo = stuinfo;
      // this.stu_name = stuinfo.studentUserInfo.realname;
      this.tch_work_id = row.id

      if (row.is_marking) {
        this.markform = {
          is_good: row.is_good,
          is_only: row.is_only,
          markpoint: row.markpoint,
          remark: row.remark,
        }
      } else {
        this.markform = {
          is_good: false,
          is_only: false,
          markpoint: '',
          remark: '',
        }
      }

      console.log('workinfo')
      console.log(this.workinfo)
      console.log('stuinfo')
      console.log(this.StuInfo)

      if (this.CourseworkForm.subject_code == '1') {
        this.project_url =
          '/jrcode/teachjr.html?role=teach&type=5&mode=edit&filepath=' +
          row.work_url +
          '&stu_user_id=' +
          row.stu_user_id +
          '&stu_tch_plan_id=' +
          row.stu_tch_plan_id +
          '&work_type=' +
          row.work_type
        this.drawer = true
      } else if (this.CourseworkForm.subject_code == '2') {
        console.log('SC作品查看')
        this.project_url =
          '/scratch/teachsc.html?workurl=' +
          this.compileStr(row.work_url).replace(/%/g, '%25') +
          '&workname=' +
          row.title +
          '&stu_user_id=' +
          row.stu_user_id +
          '&stu_tch_plan_id=' +
          row.stu_tch_plan_id +
          '&work_type=' +
          row.work_type +
          '&mode=4'

        console.log('URL')
        console.log(this.project_url)

        this.drawer = true
      } else if (this.CourseworkForm.subject_code == '3') {
        console.log(row, 5623232)
        getPrepareCurrculumMaterial({
          currMatId:
            row.stuTchPlanInfo.techPlanInfo.curriculum_meterial_id,
          tchPlanId: row.stuTchPlanInfo.techPlanInfo.id,
        }).then((res) => {
          console.log(res, 4545212)
          localStorage.setItem(
            'home_template_url',
            res.curriculumMaterial.homeTemplateUrl
          )
        })
        if (localStorage.getItem('current_py_version') == 'v2') {
          this.project_url =
            '/python/teachpy_v2?mode=4&title=' +
            this.work_title +
            '&stu_user_id=' +
            row.stu_user_id +
            '&stu_tch_plan_id=' +
            row.stu_tch_plan_id +
            '&work_type=' +
            row.work_type

          this.$store.commit('SET_TEACH_TEMPLATE_URL', row.work_url || '')
          this.drawer = true
        } else if (localStorage.getItem('current_py_version') == 'v1') {
          this.project_url =
            '/python/teachpy?mode=4&title=' +
            this.work_title +
            '&stu_user_id=' +
            row.stu_user_id +
            '&stu_tch_plan_id=' +
            row.stu_tch_plan_id +
            '&work_type=' +
            row.work_type

          this.$store.commit('SET_TEACH_TEMPLATE_URL', row.work_url || '')
          this.drawer = true
        } else {
          this.project_url =
            '/python/teachpy_v2?mode=4&title=' +
            this.work_title +
            '&stu_user_id=' +
            row.stu_user_id +
            '&stu_tch_plan_id=' +
            row.stu_tch_plan_id +
            '&work_type=' +
            row.work_type

          this.$store.commit('SET_TEACH_TEMPLATE_URL', row.work_url || '')
          this.drawer = true
        }
      }
    },
    LookOneWorkTable(row, type) {
      console.log('老师课表中查看学员作品')
      console.log(row)

      if (row.subject_id == '1') {
        if (type == '1') {
          this.project_url =
            '/jrcode/teachjr.html?role=teach&type=5&mode=edit&filepath=' +
            row.classWorkInfo.work_url +
            '&stu_user_id=' +
            row.student_user_id +
            '&stu_tch_plan_id=' +
            row.classWorkInfo.stu_tch_plan_id +
            '&work_type=' +
            row.classWorkInfo.work_type
        } else if (type == '2') {
          this.project_url =
            '/jrcode/teachjr.html?role=teach&type=5&mode=edit&filepath=' +
            row.homeWorkInfo.work_url +
            '&stu_user_id=' +
            row.student_user_id +
            '&stu_tch_plan_id=' +
            row.homeWorkInfo.stu_tch_plan_id +
            '&work_type=' +
            row.homeWorkInfo.work_type
        }

        this.drawer = true
      } else if (row.subject_id == '2') {
        console.log('SC作品查看')

        if (type == '1') {
          this.project_url =
            '/scratch/teachsc.html?workurl=' +
            this.compileStr(row.classWorkInfo.work_url).replace(/%/g, '%25') +
            '&workname=' +
            row.classWorkInfo.title +
            '&stu_user_id=' +
            row.student_user_id +
            '&stu_tch_plan_id=' +
            row.classWorkInfo.stu_tch_plan_id +
            '&work_type=' +
            row.classWorkInfo.work_type +
            '&mode=4'
        } else if (type == '2') {
          this.project_url =
            '/scratch/teachsc.html?workurl=' +
            this.compileStr(row.homeWorkInfo.work_url).replace(/%/g, '%25') +
            '&workname=' +
            row.homeWorkInfo.title +
            '&stu_user_id=' +
            row.student_user_id +
            '&stu_tch_plan_id=' +
            row.homeWorkInfo.stu_tch_plan_id +
            '&work_type=' +
            row.homeWorkInfo.work_type +
            '&mode=4'
        }

        console.log('URL')
        console.log(this.project_url)

        this.drawer = true
      } else if (row.subject_id == '3') {
        if (type == '1') {
          this.project_url =
            '/python/teachpy?mode=4&title=' +
            row.classWorkInfo.title +
            '&stu_user_id=' +
            row.student_user_id +
            '&stu_tch_plan_id=' +
            row.classWorkInfo.stu_tch_plan_id +
            '&work_type=' +
            row.classWorkInfo.work_type

          this.$store.commit(
            'SET_TEACH_TEMPLATE_URL',
            row.classWorkInfo.work_url || ''
          )
        } else if (type == '2') {
          this.project_url =
            '/python/teachpy?mode=4&title=' +
            row.homeWorkInfo.title +
            '&stu_user_id=' +
            row.student_user_id +
            '&stu_tch_plan_id=' +
            row.homeWorkInfo.stu_tch_plan_id +
            '&work_type=' +
            row.homeWorkInfo.work_type

          this.$store.commit(
            'SET_TEACH_TEMPLATE_URL',
            row.homeWorkInfo.work_url || ''
          )
        }

        this.drawer = true
      }
    },

    MarkOneWork(row) {
      if (this.$store.state.user.schoolInfo.authorize) {
        if (row.authorizer_openid) {
          this.isDisabled = false
        } else {
          this.isDisabled = true
        }
      } else {
        if (row.openid) {
          this.isDisabled = false
        } else {
          this.isDisabled = true
        }
      }
      //动态获取GPT-TOKEN
      this.getGhatGptToken()

      console.log(row, 123456)
      console.log('点评1个作品')
      console.log(row)
      this.stuId1 = row
      this.work_title = row.title
      this.work_url = row.work_url
      this.workinfo = row
      this.subject_id = row.stuTchPlanInfo.subject_id
      this.tch_work_id = row.id
      this.form_share.stuTchPlanIdTest = row.stuTchPlanInfo.id
      this.form_share.schoolIdTest = row.stuTchPlanInfo.educational_institution_id
      console.log(this.subject_id)
      if (row.is_marking) {
        this.markform = {
          is_good: row.is_good,
          is_only: row.is_only,
          markpoint: row.markpoint,
          remark: row.remark,
        }
      } else {
        this.markform = {
          is_good: false,
          is_only: false,
          markpoint: '',
          remark: '',
        }
      }
      console.log('workinfo')
      console.log(this.workinfo)
      console.log('stuinfo')
      console.log(this.StuInfo)
      if (this.CourseworkForm.subject_code == '1') {
        this.dialogFormVisible2 = true
      } else if (this.CourseworkForm.subject_code == '2') {
        this.dialogFormVisible2 = true
      } else if (this.CourseworkForm.subject_code == '3') {
        this.dialogFormVisible2 = true
        console.log('PY课堂作品')
      } else if (this.CourseworkForm.subject_code == '4') {
        this.dialogFormVisible2 = true
      }
    },

    tchSaveTchWorkScore() {
      console.log('教师点评作品')
      console.log(this.markform)
      console.log(this.subject_code)
      console.log(this.tch_work_id)

      if (!this.markform.markpoint) {
        this.$message.warning('请对作品等级进行评价!')
        return
      }

      tchSaveTchWorkScore({
        subject_code: this.subject_id,
        tch_work_id: this.tch_work_id,
        markpoint: this.markform.markpoint,
        remark: this.markform.remark,
        is_good: this.markform.is_good,
        is_only: this.markform.is_only,
      }).then((res) => {
        console.log('教师点评作品')
        console.log(res)
        if (res.is_update) {
          this.$message.success('点评成功')
          this.dialogFormVisible2 = false
          this.tchGetTchStuTchWorkList()
        }
      })
    },

    search3() {
      this.page_no3 = 1
      this.tchGetTchStuTchWorkList()
    },

    tchGetTchStuTchWorkList() {
      if (!this.CourseworkForm.subject_code) {
        this.$message.warning('请选择科目')
        return
      }

      console.log('科目信息')
      console.log(this.CourseworkForm.subject_code)

      tchGetTchStuTchWorkList({
        tch_plan_sign_date_start:
          this.CourseworkForm.creatTime1 === null
            ? ''
            : this.CourseworkForm.creatTime1[0],
        tch_plan_sign_date_end:
          this.CourseworkForm.creatTime1 === null
            ? ''
            : this.CourseworkForm.creatTime1[1],
        stuRealName: this.CourseworkForm.stuRealName,
        className: this.CourseworkForm.className,
        subject_code: this.CourseworkForm.subject_code,
        is_marking: this.CourseworkForm.is_marking,
        work_type: this.CourseworkForm.type,
        title: this.CourseworkForm.title,
        page_no: this.page_no3,
        page_size: this.page_size3,
      }).then((res) => {
        console.log('学生课堂作品')
        console.log(res)
        this.CourseWorkList = res.workList
        console.log(this.tableRow, 1245)
        this.$refs.singleTable.setCurrentRow(this.CourseWorkList[this.tableRow])
        this.total3 = res.total
      })
    },

    onSubmit() {
      this.getTchClasslist()
    },

    search() {
      this.page_no = 1
      this.teachplan_form.default_time = ''
      this.teachplan_form.latest = false
      this.tchGetTchTimetable()
    },

    //获得老师课表
    tchGetTchTimetable() {
      tchGetTchTimetable({
        title: this.teachplan_form.title,
        sign_state: this.teachplan_form.sign_state,
        start_date: this.teachplan_form.default_time
          ? this.teachplan_form.default_time
          : this.teachplan_form.date
            ? this.teachplan_form.date[0]
            : '', // 开始时间
        end_date: this.teachplan_form.date ? this.teachplan_form.date[1] : '', // 结束时间
        page_no: this.page_no,
        page_size: this.page_size,
      }).then((res) => {
        console.log('查询老师课表')
        console.log(res)
        this.teaching_plan_list = res.teaching_plan_list
        this.total = res.total
      })
    },

    //去上课
    goTeachlessons(item) {
      console.log('去上课')
      console.log(item)

      if (item.sign_state == '1') {
        console.log('课堂已解锁')
        this.$router.push({
          name: 'teachLessons',
          query: {
            curriculumMaterial_id: item.curriculum_meterial_id,
            backname: 'works',

            classid: item.curriculum_class_id,
            teaching_plan_id: item.id,
            eduCampusId: item.educational_institution_campus_id,
          },
        })
      } else {
        this.$confirm(
          '对学生进行【点名签到】后,学生端课程才可以解锁!',
          '提示',
          {
            confirmButtonText: '知道了',
            cancelButtonText: '取消',
            type: 'warning',
          }
        ).then(() => {
          this.updateTchPlanSignState(item)
        })
      }
    },

    //更新教学计划的签到状态
    updateTchPlanSignState(item) {
      updateTchPlanSignState({
        teaching_plan_id: item.id,
      }).then((res) => {
        console.log('更新教学计划的签到状态')
        console.log(res)
        if (res.is_update) {
          this.$message.success('课程已解锁,可以开始上课啦!')
          this.$router.push({
            name: 'teachLessons',
            query: {
              curriculumMaterial_id: item.curriculum_meterial_id,
              backname: 'works',

              classid: item.curriculum_class_id,
              teaching_plan_id: item.id,
              eduCampusId: item.educational_institution_campus_id,
            },
          })
        }
      })
    },

    //去备课
    prepare(item) {
      console.log(item)

      this.$router.push({
        name: 'prepare',
        query: {
          curriculumMaterial_id: item.curriculum_meterial_id,
          tchPlanId: item.id,
          backname: 'works',

          classid: item.curriculum_class_id,
        },
      })
    },

    sendTchWorkTchCommentTemplateMessage(row) {
      console.log('推送通知')
      console.log(row, 123456)
      this.form_share.stuTchPlanIdTest = row.stuTchPlanInfo.id
      this.form_share.schoolIdTest = row.stuTchPlanInfo.educational_institution_id
      this.$confirm('即将把作品推送至家长微信,是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        if (row.is_send_tch_comment_wx_message) {
          this.$confirm('已推送过点评消息,是否再次推送?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning',
          }).then(() => {
            console.log(this.CourseworkForm, 1213456)
            var to_url = ''
            var remark = ''
            if (this.CourseworkForm.subject_code == '1') {
              to_url =
                'https://steam.fun/jrcode/h5show.html?mode=look&filepath=' +
                row.work_url
              remark = '无'
            } else if (this.CourseworkForm.subject_code == '2') {
              to_url =
                'https://steam.fun/scratch/h5player.html?work_type=2&work_id=' +
                row.id +
                '&subject_code=2' + `&stuTchPlanIdTest=${this.form_share.stuTchPlanIdTest}&schoolIdTest=${this.form_share.schoolIdTest}`
              remark = '点击详情,立即体验!'
            } else if (this.CourseworkForm.subject_code == '3') {
              to_url = ''
              remark = '无'
            }

            sendTchWorkTchCommentTemplateMessage({
              tch_work_id: row.id,
              subject_code: this.CourseworkForm.subject_code,
              to_url: to_url,
              remark: remark,
            }).then((res) => {
              console.log('推送通知')
              console.log(res)
              if (res.is_send) {
                console.log('发送成功')
                this.$message.success('点评已推送至家长微信')
                this.tchGetTchStuTchWorkList()
              } else {
                this.$message.warning(res.msg)
              }
            })
          })
        } else {
          var to_url = ''
          var remark = ''
          if (this.CourseworkForm.subject_code == '1') {
            to_url = ''
            remark = '无'
          } else if (this.CourseworkForm.subject_code == '2') {
            to_url =
              'https://steam.fun/scratch/h5player.html?work_type=2&work_id=' +
              row.id +
              '&subject_code=2' + `&stuTchPlanIdTest=${this.form_share.stuTchPlanIdTest}&schoolIdTest=${this.form_share.schoolIdTest}`
            remark = '点击详情,立即体验!'
          } else if (this.CourseworkForm.subject_code == '3') {
            to_url = ''
            remark = '无'
          }

          sendTchWorkTchCommentTemplateMessage({
            tch_work_id: row.id,
            subject_code: this.CourseworkForm.subject_code,
            to_url: to_url,
            remark: remark,
          }).then((res) => {
            console.log('推送通知')
            console.log(res)
            if (res.is_send) {
              console.log('发送成功')
              this.$message.success('点评已推送至家长微信')
              this.tchGetTchStuTchWorkList()
            } else {
              this.$message.warning(res.msg)
            }
          })
        }
      })
    },

    //获得学员带参二维码
    getQrCode(row) {
      console.log('学员信息')
      console.log(row)
      console.log(row.stu_user_id)

      this.wx_stu_name = row.name

      getQrCode({
        stuId: row.stu_user_id,
      }).then((res) => {
        console.log('绑定学员家长微信')
        console.log(res)

        this.code_url =
          'data:image/jpeg;base64,' +
          this.arrayBufferToBase64(res.qucodeData.data)
        console.log('url', this.code_url)

        this.dialogVisible1 = true
      })
    },

    arrayBufferToBase64(buffer) {
      let binary = ''
      const bytes = new Uint8Array(buffer)
      const len = bytes.byteLength
      for (let i = 0; i < len; i += 1) {
        binary += String.fromCharCode(bytes[i])
      }
      return window.btoa(binary) //base64
    },

    handleClose() {
      this.dialogVisible1 = false
      this.tchGetTchStuTchWorkList()
    },

    handleCurrentPlanPage(val) {
      this.page_no = val
      this.tchGetTchTimetable()
    },

    handleCurrentClassPage(val) {
      this.page_no2 = val
      this.getTchClasslist()
    },
    handleCurrentWorks(val) {
      this.page_no3 = val
      this.tchGetTchStuTchWorkList()
    },

    handleClassClick(id) {
      console.log('班级ID')
      console.log(id)

      this.$router.push({
        name: 'classlistDescTeacher',
        query: {
          class_id: id,
        },
      })
    },
  },
}
</script>

<style lang="scss" scoped>
// /deep/.el-table__body tr.current-row>td{
//     background-color: #E1EDFF !important;
// }
/deep/ .container1 .el-drawer__body {
  overflow: hidden;
}

.school-body-index-teacher {
  background: white;
  // padding-top: 20px;
  // padding-left: 20px;
  // padding-right: 20px;
  // padding-bottom: 20px;
  border-radius: 5px;
  margin: 10px;

  .classwrapper {
    background: white;

    .classtype {
    }

    .classlist {
      border: 1px solid rgb(226, 226, 226);
      margin: 15px;
      border-radius: 5px;
      padding-bottom: 10px;

      .class_img {
        display: block;
        width: 100%;
        height: 0;
        padding-bottom: 69%;
        background-repeat: no-repeat;
        background-size: cover;
        border-radius: 5px 5px 0px 0px;

        .classimg {
          width: 100%;

          border-radius: 5px 5px 0px 0px;
        }
      }

      .class_room {
        margin-top: 10px;

        .classname {
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
          font-weight: bold;
          padding-left: 10px;
          font-size: 16px;
        }
      }

      .class_time {
        padding-left: 10px;
        line-height: 20px;
      }

      .class_num {
        padding-left: 10px;
        line-height: 20px;
      }
    }

    .pagesdiv {
      text-align: center;
      padding: 10px;
    }
  }

  .classlist_wrapper {
    .classlist-imgwrapper {
      .classimg_wrapper_img {
        width: 100%;
        border-radius: 5px;
        margin-top: 10%;
      }
    }

    .classlist-content {
      flex: 1;
      display: flex;
      flex-flow: column;

      .classlist-content-title {
        flex: 1;

        line-height: 40px;
        padding-left: 40px;
        font-weight: 500;

        .coursetitle {
          padding-right: 10px;
          font-weight: 800;
        }
      }

      .classlist-content-desc {
        flex: 1;

        line-height: 40px;
        padding-left: 40px;

        text-overflow: -o-ellipsis-lastline;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 1;
        -webkit-box-orient: vertical;

        .content-desc {
          padding-right: 20px;
        }
      }

      .classlist-content-date {
        flex: 1;

        line-height: 40px;
        padding-left: 40px;
      }
    }

    .classlist-btn {
      height: 140px;
      line-height: 140px;

      text-align: center;

      .drop_btn {
        margin-right: 20px;
        margin-top: 60px;
      }

      .class_btn {
        margin-top: 60px;
        margin-right: 20px;
      }
    }

    .pagination-style {
      margin: 20px;
    }
  }

  /*
  #qrcodeImg {
    box-sizing: border-box;
    display: inline-block;
    padding: 8px;
    background: #cccccc;
    & > img {
      display: inline-block !important;
    }
  }
  */
}

.BtnShow {
  display: none;
}

.txttag:hover .BtnShow {
  display: inline-block;
}

.fr {
  float: right;
}

.fl {
  float: left;
}

// .txttag {
//     max-width: 100px;
//     white-space: nowrap;
//     overflow: hidden; //文本超出隐藏
//     text-overflow: ellipsis; //文本超出省略号替代
// }
</style>

<style>
.BtnShow .el-button {
  line-height: 0;
}

.el-popover {
  background: #f5f7fa;
}

.container .el-drawer__header {
  margin-bottom: 0px;
  padding: 0px;
  font-weight: bold;
  border-bottom: 0px;
  background: #f9f9f9;
  text-align: center;
}

.container .el-dialog {
  border-radius: 10px !important;
}
</style>
